import { MoodSharp } from "@mui/icons-material"
import IconButton from "@mui/material/IconButton"

const Avatar = () => (
  <IconButton size="medium">
    <MoodSharp style={{ fontSize: 70 }} />
  </IconButton>
)

export { Avatar }
